import script from "./ProductAddToCartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAddToCartModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductAddToCartModal.vue?vue&type=style&index=0&id=53965e4e&lang=css"

const __exports__ = script;

export default __exports__